// externals
import type { PropsWithChildren } from 'react';
import { useHistory, useLocation } from 'react-router-dom';

// libraries
import { ConditionalProfiler } from '@makemydeal/dr-dash-components';

// components
import Routing from './routing';

export const RoutingWrapper: React.FC<PropsWithChildren> = () => {
    const history = useHistory();
    const location = useLocation();
    return (
        <ConditionalProfiler id="mv-app-shell">
            <Routing history={history} location={location} match={undefined as any} />
        </ConditionalProfiler>
    );
};
